import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/GLOrdersApi" );

export const loadOrderHistory = () => instance.get( "LoadOrderHistory" );

export const loadOurOrderHistory = () => instance.get( "LoadOurOrderHistory" );
